import React from 'react';
import ReactDOM from 'react-dom';
import Router from './components';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/store';
import { ConnectedRouter } from 'connected-react-router';
import { PersistGate } from 'redux-persist/integration/react'
import history from './lib/history';
import { registerAesKey } from './lib/crypto';
import "../src/assets/css/navbar.css";
import "../src/assets/css/style.css";
import "../src/assets/css/chkbx-radio.css";
import "../src/assets/css/font-awesome.min.css";
import "../src/services/router/shared/shared.css"
import './assets/vendor/mdi/css/materialdesignicons.min.css';
// import "../src/assets/css/viewQueryStyle.css"
registerAesKey(); // intiate the bad ass person in the world

if (process.env.NODE_ENV === "production") {
    console.log = () => { };
    console.debug = () => { };
    console.info = () => { };
    console.warn = () => { };
}

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ConnectedRouter history={history}>
                <Router />
            </ConnectedRouter>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);

//serviceWorker.register();